
<div class="page-customized">
    <v-progress-linear
        v-if="overlay"
        absolute
        indeterminate
    ></v-progress-linear>

    <app-bar
        :title="club.exists() ? t('club_title_update') : t('club_title_create')"
        back="/clubs"
    />

    <v-layout class="mt-n8">
        <v-card
            width="100%"
            color="transparent"
            elevation="0"
            class="pb-8"
        >
            <v-card-text class="pb-0">
                <v-form class="mt-6">
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_label_name') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="club.name"
                                type="text"
                                required
                                outlined
                                dense
                                :error-messages="form.errors.get('name')"
                            ></v-text-field>
                        </div>
                        <div class="horizontal-actions">
                            <edit-translations-modal
                                v-model="club.name"
                                :items="club.translations['name']"
                                @touch="(v) => club.translations['name'] = v"
                            ></edit-translations-modal>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_label_description') }}</div>
                        <div class="horizontal-input">
                            <v-textarea
                                v-model="club.description"
                                outlined
                                dense
                                :error-messages="form.errors.get('description')"
                            ></v-textarea>
                        </div>
                        <div class="horizontal-actions">
                            <edit-translations-modal
                                v-model="club.description"
                                :items="club.translations['description']"
                                @touch="(v) => club.translations['description'] = v"
                                text
                            ></edit-translations-modal>
                        </div>
                    </div>
                    <div class="form-group-horizontal-cols">
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('club_label_country') }}</div>
                            <div class="horizontal-input">
                                <v-select
                                    v-model="club.country"
                                    :items="[ { text: '-', value: '' } ].concat(countries())"
                                    outlined
                                    dense
                                    clearable
                                    append-icon="mdi-chevron-down"
                                    :error-messages="form.errors.get('country')"
                                ></v-select>
                            </div>
                        </div>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('club_label_sort_order') }}</div>
                            <div class="horizontal-input">
                                <v-text-field
                                    v-model="club.sortOrder"
                                    type="number"
                                    step="1"
                                    outlined
                                    dense
                                    :error-messages="form.errors.get('sort_order')"
                                ></v-text-field>
                            </div>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_label_logo') }}</div>
                        <div class="horizontal-input">
                            <v-file-input
                                v-model="club.photo"
                                outlined
                                prepend-icon=""
                                prepend-inner-icon="mdi-paperclip"
                                :append-outer-icon="club.photoUrl ? 'mdi-eye-outline' : ''"
                                dense
                                :error-messages="photoForm.errors.get('photo')"
                                @click:append-outer="viewPhoto(club.photoUrl)"
                                @click:clear="club.photo = undefined"
                            ></v-file-input>
                        </div>
                    </div>
                    <div class="form-group-horizontal" v-if="club.photos && club.photos.length">
                        <v-sheet
                            v-for="(photo, i) in club.photos"
                            :key="photo"
                            color="white"
                            elevation="0"
                            height="200"
                            width="200"
                            class="float-left mr-8 mb-8 bordered position-relative"
                        >
                            <v-img
                                :lazy-src="photo"
                                :src="photo"
                                max-height="150"
                                max-width="150"
                                class="mx-auto mt-6"
                            ></v-img>
                            <confirm-modal
                                :title="t('general_title_confirm_action')"
                                @agree="club.delPhoto(i)"
                            >
                                <template #default="{ on, attrs }">
                                    <v-btn
                                        v-on="on"
                                        v-bind="attrs"
                                        plain
                                        icon
                                        absolute
                                        top
                                        right
                                        class="mt-n5 mr-n5"
                                    ><v-icon color="orange">mdi-close</v-icon></v-btn>
                                </template>
                            </confirm-modal>
                            <v-btn
                                v-if="i !== 0"
                                @click="club.updatePhotoNumber(i, (i - 1))"
                                plain
                                icon
                                absolute
                                bottom
                                left
                                class="mb-n5 ml-n5"
                            ><v-icon color="customized-primary">mdi-arrow-left</v-icon></v-btn>
                            <v-btn
                                v-if="i !== club.photos.length - 1"
                                @click="club.updatePhotoNumber(i, (i + 1))"
                                plain
                                icon
                                absolute
                                bottom
                                right
                                class="mb-n5 mr-n5"
                            ><v-icon color="customized-primary">mdi-arrow-right</v-icon></v-btn>
                        </v-sheet>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_label_header_photos') }}</div>
                        <div class="horizontal-input">
                            <v-file-input
                                v-model="club.photoUps"
                                outlined
                                prepend-icon=""
                                prepend-inner-icon="mdi-paperclip"
                                dense
                                multiple
                                :error-messages="photoForm.errors.get('photos.0') || photoForm.errors.get('photos')"
                                @click:clear="club.photoUps = undefined"
                            ></v-file-input>
                        </div>
                    </div>
                    <div class="form-group-horizontal" v-if="club.landingPhotos && club.landingPhotos.length">
                        <v-sheet
                            v-for="(photo, i) in club.landingPhotos"
                            :key="photo"
                            color="white"
                            elevation="0"
                            height="200"
                            width="200"
                            class="float-left mr-8 mb-8 bordered position-relative"
                        >
                            <v-img
                                :lazy-src="photo"
                                :src="photo"
                                max-height="150"
                                max-width="150"
                                class="mx-auto mt-6"
                            ></v-img>
                            <confirm-modal
                                :title="t('general_title_confirm_action')"
                                @agree="club.delLandingPhoto(i)"
                            >
                                <template #default="{ on, attrs }">
                                    <v-btn
                                        v-on="on"
                                        v-bind="attrs"
                                        plain
                                        icon
                                        absolute
                                        top
                                        right
                                        class="mt-n5 mr-n5"
                                    ><v-icon color="orange">mdi-close</v-icon></v-btn>
                                </template>
                            </confirm-modal>
                            <v-btn
                                v-if="i !== 0"
                                @click="club.updateLandingPhotoNumber(i, (i - 1))"
                                plain
                                icon
                                absolute
                                bottom
                                left
                                class="mb-n5 ml-n5"
                            ><v-icon color="customized-primary">mdi-arrow-left</v-icon></v-btn>
                            <v-btn
                                v-if="i !== club.landingPhotos.length - 1"
                                @click="club.updateLandingPhotoNumber(i, (i + 1))"
                                plain
                                icon
                                absolute
                                bottom
                                right
                                class="mb-n5 mr-n5"
                            ><v-icon color="customized-primary">mdi-arrow-right</v-icon></v-btn>
                        </v-sheet>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_label_landing_photos') }}</div>
                        <div class="horizontal-input">
                            <v-file-input
                                v-model="club.landingUps"
                                outlined
                                prepend-icon=""
                                prepend-inner-icon="mdi-paperclip"
                                dense
                                multiple
                                :hint="t('club_hint_landing_photos')"
                                persistent-hint
                                :error-messages="photoForm.errors.get('landing.0') || photoForm.errors.get('landing')"
                                @click:clear="club.landingUps = undefined"
                            ></v-file-input>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('general_action_published') }}</div>
                        <div class="horizontal-input">
                            <v-switch
                                class="ma-0"
                                v-model="club.enabled"
                            ></v-switch>
                        </div>
                    </div>
                </v-form>
            </v-card-text>

            <v-card-title class="px-4">{{ t('club_label_sections') }}</v-card-title>

            <v-card-text>
                <v-card
                    v-for="(section, sIndex) in club.sections"
                    :key="`section_${sIndex}`"
                    outlined
                    class="mb-6 pa-4 bordered"
                >
                    <div class="d-flex align-start justify-space-between mb-2">
                        <div class="form-group-horizontal" style="width: auto">
                            <div class="horizontal-label">{{ t('club_section_label_name') }}</div>
                            <div class="horizontal-input">
                                <v-text-field
                                    v-model="section.name"
                                    outlined
                                    dense
                                    :error-messages="form.errors.get(`sections.${sIndex}.name`)"
                                ></v-text-field>
                            </div>
                            <div class="horizontal-actions">
                                <edit-translations-modal
                                    v-model="section.name"
                                    :items="section.translations['name']"
                                    @touch="(v) => section.translations['name'] = v"
                                ></edit-translations-modal>
                            </div>
                        </div>
                        <div>
                            <v-btn
                                v-if="sIndex !== 0"
                                @click="club.moveSection(sIndex, -1)"
                                icon
                                class="mr-2"
                            ><v-icon>mdi-arrow-up</v-icon></v-btn>
                            <v-btn
                                v-if="sIndex !== club.sections.length - 1"
                                @click="club.moveSection(sIndex, 1)"
                                icon
                                class="mr-2"
                            ><v-icon>mdi-arrow-down</v-icon></v-btn>
                            <confirm-modal
                                :title="t('general_title_confirm_action')"
                                @agree="club.removeSection(sIndex)"
                            >
                                <template #default="{ on, attrs }">
                                    <v-btn
                                        v-on="on"
                                        v-bind="attrs"
                                        class="exs"
                                        color="orange"
                                        small
                                    >{{ t('general_action_delete') }}</v-btn>
                                </template>
                            </confirm-modal>
                        </div>
                    </div>

                    <v-simple-table class="transparent">
                        <template #default>
                            <thead>
                            <tr>
                                <th>{{ t('club_element_label_type') }}</th>
                                <th>{{ t('club_element_label_name') }}</th>
                                <th>{{ t('club_element_label_premium') }}</th>
                                <th class="text-center">{{ t('general_label_action') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="section.elements.length === 0">
                                <td colspan="4" class="text-center">{{ t('general_text_no_data') }}</td>
                            </tr>
                            <tr
                                v-for="(element, eIndex) in section.elements"
                                :key="`element_${sIndex}_${eIndex}`"
                            >
                                <td>{{ elementTypeTitle(element.type) }}</td>
                                <td class="titled">{{ element.name }}</td>
                                <td>
                                    <v-switch
                                        class="ma-0"
                                        v-model="element.isPremium"
                                        hide-details
                                    ></v-switch>
                                </td>
                                <td class="text-center">
                                    <v-menu
                                        offset-y
                                        left
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            <v-list-item
                                                v-if="eIndex > 0"
                                                @click.prevent="section.moveElement(eIndex, -1)"
                                            >
                                                <v-list-item-title
                                                    class="customized-primary--text"
                                                >{{ t('general_action_move_up') }}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                v-if="eIndex < section.elements.length - 1"
                                                @click.prevent="section.moveElement(eIndex, 1)"
                                            >
                                                <v-list-item-title
                                                    class="customized-primary--text"
                                                >{{ t('general_action_move_down') }}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                @click.prevent="section.removeElement(eIndex)"
                                            >
                                                <v-list-item-title
                                                    class="orange--text"
                                                >{{ t('general_action_delete') }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <div class="form-group-horizontal-cols mt-8">
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('club_element_label_type') }}</div>
                            <div class="horizontal-input">
                                <v-select
                                    v-model="section.newElementType"
                                    :items="elementTypeOptions()"
                                    outlined
                                    dense
                                    append-icon="mdi-chevron-down"
                                    @change="onElementTypeChange(section)"
                                ></v-select>
                            </div>
                        </div>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('club_element_label_item') }}</div>
                            <div class="horizontal-input">
                                <v-autocomplete
                                    v-model="section.newElementId"
                                    :items="itemsForType(section.newElementType)"
                                    :disabled="! section.newElementType"
                                    :loading="loadingType === section.newElementType"
                                    outlined
                                    dense
                                    append-icon="mdi-chevron-down"
                                ></v-autocomplete>
                            </div>
                        </div>
                        <div class="form-group-horizontal" style="width: auto">
                            <v-switch
                                class="ma-0 mt-2"
                                v-model="section.newElementPremium"
                                :label="t('club_element_label_premium')"
                            ></v-switch>
                        </div>
                    </div>
                    <div class="horizontal-actions">
                        <v-btn
                            @click="addElement(section)"
                            :disabled="! section.newElementType || ! section.newElementId"
                            color="primary"
                            class="sm"
                        >{{ t('club_element_action_add') }}</v-btn>
                    </div>
                </v-card>

                <v-btn
                    @click="club.addSection()"
                    v-ripple="false"
                    plain
                    color="orange darken-4"
                    class="add"
                ><v-icon left size="16">mdi-plus-circle</v-icon>{{ t('club_section_action_add') }}</v-btn>
            </v-card-text>

            <v-card-actions class="px-4">
                <v-btn
                    :to="{ name: 'clubs' }"
                    class="mr-4"
                    color="primary"
                >{{ t('general_action_cancel') }}</v-btn>
                <v-btn
                    :loading="form.busy"
                    :disabled="form.busy"
                    color="orange"
                    @click.prevent="submit"
                >{{ club.exists() ? t('general_action_save') : t('club_title_create') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-layout>
</div>
